module.exports = __webpack_public_path__ + "static/media/auto-fc-gator.1ee02045.svg";